module.exports = __webpack_public_path__ + "media/images/character-img-service-intro-area-e5aecad410b2dfb8ea76094e5b135b6f.png";